import React from "react";
import { Form } from "react-bootstrap";

const UpdatePassword = ({ handleChange }) => {
  return (
    <>
      <div>
        <Form>
          <Form.Label>Type New Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            name="password"
            required={true}
            onChange={handleChange}
          />
          <Form.Label className="mt-3">Confirm New Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Confirm Cassword"
            name="confirmPassword"
            required={true}
            onChange={handleChange}
          />
        </Form>
      </div>
    </>
  );
};

export default UpdatePassword;
